import React,{useState} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import AddArticleForm from '../Components/Articles/AddArticleForm'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection } from 'firebase/firestore';
const AddArticle = () => {
    const [blogTitle, setBlogTitle] = useState("")
    const [blogContent, setBlogContent] = useState("")
    const [coverImage, setCoverImage] = useState("")
    const [link, setLink] = useState("")
    const addCoverImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setCoverImage(downloadURL)
         console.log(downloadURL)
       });
     }
   );
    }
    const handleAdd = () =>{
        addDoc(collection(db, "articles"),{
            name: blogTitle,
            contentOne:blogContent,
            link:link,
            coverImage:coverImage,
     
         })
         setBlogTitle("")
         setBlogContent("")
         setLink("")
         setCoverImage("")
    }
  return (
    <div className=' bg-gray-200  ' >
      <MultiLevelSidebar />
    <AddArticleForm blogTitle={blogTitle} setBlogTitle={setBlogTitle}
        blogContent={blogContent} setBlogContent={setBlogContent}
        coverImage={coverImage} setCoverImage={setCoverImage}
        link={link} setLink={setLink}
        addCoverImage={addCoverImage}
        handleAdd={handleAdd}
      />

    </div>
  )
}

export default AddArticle